export default __webpack_public_path__ + "static/media/join-speakers-content.dddee69f.png";